module.exports = __webpack_public_path__ + "img/login.eb2a26ef.png";